import script from "./DetalleCompetencia.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalleCompetencia.vue?vue&type=script&setup=true&lang=js"

import "./DetalleCompetencia.vue?vue&type=style&index=0&id=553f2ae0&lang=scss&scoped=true"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AccessIntegrationSite\\access-integration\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-553f2ae0"]])

export default __exports__